import Url from "url-parse";
export function classifyAsset(uri) {
    var _query_contentType, _query_contentType1, _query_contentType2;
    var _ref = new Url(uri, {}, {
        parser: true
    }), _pathname = _ref.pathname, query = _ref.query;
    var pathname = _pathname.toLowerCase();
    var isVideo = pathname.endsWith('.mov') || pathname.endsWith('.mp4') || pathname.endsWith('.mov') || ((_query_contentType = query.contentType) === null || _query_contentType === void 0 ? void 0 : _query_contentType.includes('video'));
    var isAudio = pathname.endsWith('.mp3') || ((_query_contentType1 = query.contentType) === null || _query_contentType1 === void 0 ? void 0 : _query_contentType1.includes('audio'));
    var isImage = uri.startsWith('data:image') || pathname.startsWith('data:image') || pathname.endsWith('.jpeg') || pathname.endsWith('.jpg') || pathname.endsWith('.heic') || pathname.endsWith('.png') || ((_query_contentType2 = query.contentType) === null || _query_contentType2 === void 0 ? void 0 : _query_contentType2.includes('image'));
    return {
        isVideo: isVideo,
        isAudio: isAudio,
        isImage: isImage
    };
}
